/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('EventTypeController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		EventTypeFactory,
		FindAllEventTypesByQueryParamsNonPageableFactory,
		NoPagingEventTypeFactory
	) {
		$scope.eventTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('eventtype.list.new');
		};

		$scope.goToEditState = function(eventType) {
			// this overview is NOT mapped, it is the main overview
			$state.go('eventtype.list.edit', { eventTypeId: eventType.id });
		};

		$scope.getEventTypeList = function() {
			FindAllEventTypesByQueryParamsNonPageableFactory.query(
				{
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.eventTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getEventTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedEventTypeId = id;
			$('#deleteEventTypeConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			EventTypeFactory.delete(
				{ id: $scope.selectedEventTypeId },
				function() {
					$scope.loadAll();
					$('#deleteEventTypeConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteEventTypeConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
